(function () {
  function disableEmptyCompareButtons() {
    document.querySelectorAll('a.compare-button').forEach(function (anchor) {
      var href = (anchor.getAttribute('href') || '').trim();
      if (!href || href === '#') {
        anchor.classList.add('disabled');
        anchor.setAttribute('aria-disabled', 'true');
        anchor.setAttribute('tabindex', '-1');
        anchor.removeAttribute('href');
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', disableEmptyCompareButtons);
  } else {
    disableEmptyCompareButtons();
  }
})();
